<div class="agent-portfolio-container">
  <table class="portfolio-table" *ngIf="customers.length">
    <thead>
      <tr class="row header">
        <th>
          <mat-checkbox
            [checked]="isAllLocationsSelected()"
            [indeterminate]="isPartialSelectedAll()"
            (change)="toggleAllLocations($event.checked)"
          >
          </mat-checkbox>
          <div class="sortable-column">
            {{ "agent.portfolio.company" | translate }}
            <div class="sort-actions">
              <span
                class="arrow-up"
                [class.active]="
                  activeSortMode == 'asc' && activeSortKey == 'name'
                "
                (click)="sortByKey('name', 'asc')"
              ></span>
              <span
                class="arrow-down"
                [class.active]="
                  activeSortMode == 'desc' && activeSortKey == 'name'
                "
                (click)="sortByKey('name', 'desc')"
              ></span>
            </div>
          </div>
        </th>
        <th class="sortable-column">
          {{ "agent.portfolio.locations" | translate }}
          <div class="sort-actions">
            <span
              class="arrow-up"
              [class.active]="
                activeSortMode == 'asc' && activeSortKey == 'locations'
              "
              (click)="sortByKey('locations', 'asc')"
            ></span>
            <span
              class="arrow-down"
              [class.active]="
                activeSortMode == 'desc' && activeSortKey == 'locations'
              "
              (click)="sortByKey('locations', 'desc')"
            ></span>
          </div>
        </th>
        <th class="sortable-column">
          {{ "agent.listing.orders" | translate }}
          <div class="sort-actions">
            <span
              class="arrow-up"
              [class.active]="
                activeSortMode == 'asc' && activeSortKey == 'order_count'
              "
              (click)="sortByKey('order_count', 'asc')"
            ></span>
            <span
              class="arrow-down"
              [class.active]="
                activeSortMode == 'desc' && activeSortKey == 'order_count'
              "
              (click)="sortByKey('order_count', 'desc')"
            ></span>
          </div>
        </th>
        <th class="sortable-column">
          {{ "agent.listing.total_amount" | translate }}
          <div class="sort-actions">
            <span
              class="arrow-up"
              [class.active]="
                activeSortMode == 'asc' && activeSortKey == 'total_amount'
              "
              (click)="sortByKey('total_amount', 'asc')"
            ></span>
            <span
              class="arrow-down"
              [class.active]="
                activeSortMode == 'desc' && activeSortKey == 'total_amount'
              "
              (click)="sortByKey('total_amount', 'desc')"
            ></span>
          </div>
        </th>
        <th class="sortable-column">
          {{ "agent.listing.last_order" | translate }}
          <div class="sort-actions">
            <span
              class="arrow-up"
              [class.active]="
                activeSortMode == 'asc' && activeSortKey == 'last_order'
              "
              (click)="sortByKey('last_order', 'asc')"
            ></span>
            <span
              class="arrow-down"
              [class.active]="
                activeSortMode == 'desc' && activeSortKey == 'last_order'
              "
              (click)="sortByKey('last_order', 'desc')"
            ></span>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <cdk-virtual-scroll-viewport itemSize="50" class="portfolio-viewport">
        <ng-container
          *cdkVirtualFor="
            let company of customers;
            trackBy: trackByCustomerId
          "
        >
          <!-- Company row -->
          <tr
            class="row"
            [style]="{
              height: '70px'
            }"
          >
            <td>
              <mat-checkbox
                [checked]="isCompanyFullySelected(company.id)"
                [indeterminate]="isCompanyPartiallySelected(company.id)"
                (change)="toggleCompanyLocations(company.id, $event.checked)"
              ></mat-checkbox>
              <span
                class="truncate"
                style="width: 300px"
                [title]="company.name"
              >
                {{ company.name }}
              </span>
            </td>
            <td>
              <div style="display: flex; flex-direction: column">
                <span>
                  {{ company.nbr_locations_with_agent }}
                </span>
                <span class="secondary-text">
                  Out of {{ company.nbr_locations }}
                </span>
              </div>
            </td>
            <td>
              {{ company.order_count }}
            </td>
            <td>
              {{
                company.total_amount
                  ? company.total_amount.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    }) + " €"
                  : "--"
              }}
            </td>
            <td
              class="last-column"
            >
              <span>
                {{ company.last_order | adaptToUserUtcOffset | date: DATE_TIME_FORMAT || "--" }}
              </span>
              <button
                class="action-btn secondary-btn icon-btn"
                (click)="toggleCompanyExpand(company)"
              >
                <img
                  src="assets/icones/arrow.svg"
                  alt=""
                  class="arrow-icon"
                  [class.rotated]="!isCompanyExpanded(company)"
                />
              </button>
            </td>
          </tr>
          <!-- Location rows -->
          <tr
            class="row secondary-row"
            *ngFor="let location of company.locations"
            [@expandCollapse]="
              isCompanyExpanded(company) ? 'expanded' : 'collapsed'
            "
          >
            <td>
              <!-- <mat-checkbox
                [checked]="selectedLocations.includes(location.id!)"
                (change)="toggleLocation(location.id!, $event.checked)"
              >
              </mat-checkbox> -->
              <img src="assets/icones/include_icon.svg" alt="" />
              <div style="display: flex; flex-direction: column">
                <span
                  class="truncate"
                  style="width: 250px"
                  [title]="location.name"
                >
                  {{ location.name }}
                </span>
                <span
                  style="width: 250px"
                  class="secondary-text truncate"
                  [title]="location.apartment"
                >
                  {{ location.apartment }}
                </span>
              </div>
            </td>
            <td>
              <span *ngIf="location.is_main" class="tag">
                {{ "agent.portfolio.location.main" | translate }}
              </span>
            </td>
            <td>
              {{ location.order_count }}
            </td>
            <td>
              {{
                location.total_amount
                  ? location.total_amount.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    }) + " €"
                  : "--"
              }}
            </td>
            <td
              style="
                justify-content: space-between !important;
                display: flex;
                flex-direction: row;
              "
            >
              <span class="last-column">
                {{ location.last_order | adaptToUserUtcOffset | date: DATE_TIME_FORMAT || "--" }}
              </span>
              <button
                [matMenuTriggerFor]="menu"
                style="width: 44px; height: 44px; color: unset"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu" yPosition="below" xPosition="before">
                <button
                  mat-menu-item
                  class="edit-btn"
                  (click)="goToDetails(location)"
                >
                  <app-svg-icon svgIcon="pen-cc"></app-svg-icon>
                  {{ "agent.actions.edit" | translate }}
                </button>
                <button
                  mat-menu-item
                  class="delete-btn"
                  (click)="
                    locationsToDelete.push(location.id); deleteConfirmation()
                  "
                >
                  <app-svg-icon svgIcon="trash-cc"></app-svg-icon>
                  {{ "agent.actions.remove_portfolio" | translate }}
                </button>
              </mat-menu>
            </td>
          </tr>
        </ng-container>
      </cdk-virtual-scroll-viewport>
    </tbody>
  </table>
  <ng-container *ngIf="customers.length === 0">
    <div class="no-data-container">
      <img src="assets/images/shop.svg" alt="" />
      <span class="no-data-msg">
        {{ "agent.single_agent.portfolio.no_data_msg" | translate }}
      </span>
      <p
        class="no-data-desc"
        [innerHTML]="'agent.single_agent.portfolio.no_data_desc' | translate"
      ></p>
      <button class="action-btn primary-btn" (click)="openAddPortfolioDialog()">
        <span class="icon"
          ><app-svg-icon svgIcon="plus-cc"></app-svg-icon
        ></span>
        <span>{{ "agent.actions.add_companies" | translate }}</span>
      </button>
    </div>
  </ng-container>
</div>
